// Production
export default {
    apiUrl: 'https://api.tambaq.com'
    // apiUrl: 'http://192.168.0.11:3370'
}

// // Development
// export default {
//   apiUrl: 'http://main.hati.co.id/erp-api-hati-dev',
//   apiUrl2: 'http://app.hati.co.id'
// }
